import React from 'react'
import { Switch, Route,withRouter } from "react-router-dom";
import AuthViews from 'views/auth-views/index'

export const AuthLayout = (props) => {
	return (
		<div className="auth-container">
             <AuthViews/>
		</div>
	)
}


export default withRouter(AuthLayout)
